import { handleApiError } from "../utils/apiUtils";
import { formatAppointmentDateTime } from "../utils/dateUtils";
import { preventDuplicateRequest } from "../utils/requestManager";
import api from "./Api";

const PICKLIST_URL = process.env.REACT_APP_PICKLIST_URL || ""; 
const picklistAPI = api(PICKLIST_URL);


const Case = process.env.REACT_APP_CASE_URL || "";
const caseAPI = api(Case);

export const getUserMappingSearch = async (params: any): Promise<any> => {
  const key = `getUserMappingSearch-${JSON.stringify(params)}`;

  return preventDuplicateRequest(key, async () => {
    try {
      const response = await picklistAPI.post(
        "/api/team/user-mapping/search",
        params,
      );

      const updatedResult = response.data?.result.map((data: any) => ({
        ...data,
        primaryRoleDisplayName: `${data?.primaryRoleUserFullName} | ${data?.primaryRoleUserRoleNames}`,
        mappedRole: data?.roleMappingDisplayNames || "",
        mappedUser: data?.roleMappingUserFullNames || "",
        userMappingUploadedOnBy:
          formatAppointmentDateTime(data?.modifiedDate) || "",
        actions: { Edit: "Edit" },
      }));

      return updatedResult;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  });
};

export const getUserMappingLimitedRoles = async (): Promise<any> => {
  const key = "getUserMappingLimitedRoles";

  return preventDuplicateRequest(key, async () => {
    try {
      const response = await picklistAPI.get(
        "/api/team/user-mapping/limited-roles",
      );

      const updatedResult = response.data?.result.map((data: any) => ({
        value: data.roleId,
        label: data.roleName,
      }));

      return updatedResult;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  });
};

export const getUserMappingUserListByRoleID = async (
  params: any,
): Promise<any> => {
  const key = `getUserMappingUserListByRoleID-${JSON.stringify(params)}`;

  return preventDuplicateRequest(key, async () => {
    try {
      const response = await picklistAPI.post(
        "/api/team/user-mapping/user-list/by-teamid-roleid",
        params,
      );
      const updatedResult = response.data?.result
        ?.filter((data: any) => data.userId)
        .map((data: any) => ({
          ...data,
          value: data.userId,
          label: data.userFullName,
        }));

      return updatedResult;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  });
};

export const getUserMappingDetails = async (teamUserMappingId: number): Promise<any> => {
  try {
    const response = await picklistAPI.get(`/api/team/user-mapping/details?teamUserMappingId=${teamUserMappingId}`);
    return response.data?.result;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const addUserMappingDetails = async (payload: any): Promise<any> => {
  try {
    const response = await picklistAPI.post("/api/team/user-mapping/add", payload);
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const updateUserMappingDetails = async (payload: any): Promise<any> => {
  try {
    const response = await picklistAPI.post("/api/team/user-mapping/update", payload);
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const getTeamIdByUserId = async (): Promise<any> => {
  try {
    const response = await caseAPI.get(`/api/case/information/getTeamId`);
    return response.data?.result;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};